import {checkFormField} from "../../common/form/checkFormField";

const componentSelector = 'section.pay-button';

const payTokenAttribute = 'data-pay-token';
const payScriptScrAttribute = 'data-pay-script';
const payButtonSelector = `button[${payTokenAttribute}][${payScriptScrAttribute}]`;

const inputSelector = 'input[name]';

const notEmptyClass = 'not-empty';
const sentClass = 'sent';

const isFormValid = ( form ) => {
	if ( !form.classList.contains( `on` ) )
	{
		form.addEventListener(`keyup`, (evtKeyUp) => evtKeyUp.target.getAttribute(`data-required`) === `yes` ? checkFormField(evtKeyUp.target) : false);
		form.addEventListener(`change`, (evtChange) => evtChange.target.getAttribute(`data-required`) === `yes` ? checkFormField(evtChange.target) : false);
		
		form.classList.add( `on` );
	}
	
	Array.from(form.querySelectorAll(`[data-required="yes"]`)).forEach((element) => checkFormField( element ));
	
	return form.querySelectorAll( 'ul.fields > li.invalid' ).length === 0;
};

const setPayButtonClickHandler = ( component, payButton ) => {
	const form = component.querySelector( 'form' );
	const closeSentMessageButton = component.querySelector( 'div.sent button.close-message' );
	
	if ( form && closeSentMessageButton )
	{
		closeSentMessageButton.addEventListener( 'click', ( evt ) => {
			evt.preventDefault();
			evt.stopPropagation();
			evt.stopImmediatePropagation();
			
			form.classList.remove( sentClass );
		} );
		
		payButton.addEventListener( 'click', ( evt ) => {
			evt.preventDefault();
			evt.stopPropagation();
			evt.stopImmediatePropagation();
			
			if ( isFormValid( form ) )
			{
				const fields = Array.from( component.querySelectorAll( 'ul.fields > li:not(.invalid,.submit,.personal-data)' ) );
				
				if ( fields.length > 0 )
				{
					const inputs = fields.map( ( li ) => li.querySelector( inputSelector ) );
					
					const fullNameInput = inputs.find( ( input ) => input.name === "full_name" );
					const contractNameInput = inputs.find( ( input ) => input.name === "contract" );
					const emailNameInput = inputs.find( ( input ) => input.name === "email" );
					const phoneNameInput = inputs.find( ( input ) => input.name === "phone" );
					
					if ( fullNameInput && contractNameInput && emailNameInput && phoneNameInput )
					{
						const description = (
							`ФИО: ${fullNameInput.value}; \t\n` +
							`Договор: ${contractNameInput.value}; \t\n` +
							`Email: ${emailNameInput.value}; \t\n` +
							`Телефон: ${phoneNameInput.value} `
						);
						
						try {
							/*
								В методы showSuccessfulPurchase и showFailurefulPurchase
								передаётся объект с информацией об оплате
							*/
							const showSuccessfulPurchase = ( order ) => {
								if ( window.showSuccessfulPurchase )
								{
									window.showSuccessfulPurchase( order );
								}
							};
							
							const showFailurefulPurchase = ( order ) => {
								if ( window.showSuccessfulPurchase )
								{
									window.showFailurefulPurchase( order );
								}
							};
							
							window.ipayCheckout(
								{
									currency: 'RUB',
									order_number: '',
									description: description,
								},
								showSuccessfulPurchase,
								showFailurefulPurchase
							);
							
							form.classList.add( sentClass );
							
							inputs.forEach( ( input ) => input.value = '' );
							form.querySelectorAll( `li.${notEmptyClass}` )
								.forEach( ( li ) => {
									li.classList.remove( notEmptyClass );
								} )
						} catch (error) {
							window.console.error( error );
						}
					}
				}
			}
		} );
	}
};

const initPayButton = () => {
	const payScript = document.createElement( 'script' );
	let isPayScriptInit = false;
	
	document.querySelectorAll( componentSelector )
		.forEach( ( component ) => {
			const payButton = component.querySelector( payButtonSelector );
			
			if ( payButton )
			{
				const token = payButton.getAttribute( payTokenAttribute );
				const payScriptSrc = payButton.getAttribute( payScriptScrAttribute );
				
				payButton.setAttribute( payTokenAttribute, '' );
				payButton.setAttribute( payScriptScrAttribute, '' );
				
				if ( !isPayScriptInit )
				{
					payScript.src = payScriptSrc;
					document.head.appendChild( payScript );
					
					payScript.addEventListener( 'load', () => {
						if ( window.IPAY )
						{
							const IPAY = window.IPAY;
							const ipay = new IPAY( {api_token: token} );
						}
						else
						{
							window.console.error( 'Объект IPAY не инициализирован' );
						}
					} );
					
					isPayScriptInit = true;
				}
				
				if ( !window.IPAY )
				{
					payScript.addEventListener( 'load', () => {
						setPayButtonClickHandler( component, payButton );
					} );
				}
				else
				{
					setPayButtonClickHandler( component, payButton );
				}
			}
		} );
};

export {
	initPayButton,
};
